import { isProduction } from "@utils/env";

const API_ENDPOINT = isProduction
  ? "https://api.copicake.com"
  : "http://localhost:8080";

export const INTERNAL_SERVER_URL = `${API_ENDPOINT}/internal`;
